
import axios from "axios";
import moment from 'moment'

export default {
  namespaced: true,
  state: {
      lista: [],
      dt1: moment().format('YYYY-MM-DD'),
      dt2: moment().format('YYYY-MM-DD'),
      id: null,
      documento: null,
      clienteId: null,
      tipoSituacao: null,
      registroSelecionadoId: null,
      paginaAtual: 1,
  },
  getters: {
    LISTA: state => {
        return state.lista
    },
    DT1: state => {
        return state.dt1
    },
    DT2: state => {
        return state.dt2
    },
    ID: state => {
        return state.id
    },
    CLIENTE_ID: state => {
        return state.clienteId
    },
    DOCUMENTO: state => {
        return state.documento
    },
    TIPO_SITUACAO: state => {
        return state.tipoSituacao
    },
    REGISTRO_SELECIONADO_ID: state => {
        return state.registroSelecionadoId
    },
    PAGINA_ATUAL: state => {
        return state.paginaAtual
    }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_DT1: (state, payload) => {
          state.dt1 = payload
      },
      SET_DT2: (state, payload) => {
          state.dt2 = payload
      },
      SET_ID: (state, payload) => {
          state.id = payload
      },
      SET_CLIENTE_ID: (state, payload) => {
          state.clienteId = payload
      },
      SET_DOCUMENTO: (state, payload) => {
          state.documento = payload
      },
      SET_TIPO_SITUACAO: (state, payload) => {
          state.tipoSituacao = payload
      },
      SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
          state.registroSelecionadoId = payload
      },
      SET_PAGINA_ATUAL: (state, payload) => {
          state.paginaAtual = payload
      }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GERAR_LISTA: ({ commit, getters}) => {
        return new Promise((resolve, reject) => {
          let id = (getters.ID !== null ? getters.ID : '')
          let clienteId = (getters.CLIENTE_ID !== null ? getters.CLIENTE_ID : '')
          let documento = (getters.DOCUMENTO !== null ? getters.DOCUMENTO : '')
          let tipoSituacao = (getters.TIPO_SITUACAO !== null ? getters.TIPO_SITUACAO : '')
          let dt1 = (getters.DT1 !== null ? getters.DT1 : '')
          let dt2 = (getters.DT2 !== null ? getters.DT2 : '')

          let uri =  `/api/protected/compragado/pesquisar?id=${id}&dt1=${dt1}`+
                     `&dt2=${dt2}&tipoSituacao=${tipoSituacao}&clienteId=${clienteId}&documento=${documento}`
          axios
            .get(uri)
            .then(({ data, status }) => {
              commit("SET_LISTA", data);
              if (status === 200 || status === 201) {
                resolve({ data, status });
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      },
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/compra-gado-store.js